export default __webpack_public_path__ + "static/media/TreasureBox.d7651dcf.svg";